import React, { useState, useEffect } from "react";
import {
  DateInput,
  TextInput,
  SelectInput,
  FileInput,
  RadioInput,
  NumberInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { authActions, inmateAction, masterActions, publicUserActions } from "../../_store";
import { history } from "../../_helpers";
import CustomLoader from "./../../components/common/ui/Loader";
import Table from "../../components/common/table/Table";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import {
  getPastDate,
  getCurrentDate,
  fDate,
  MinDate,
  Today,
} from "../../utils/formatTime.js";
import Pending from "../../assets/svg/pending-user.svg";
import Approved from "../../assets/svg/approved.svg";
import generateXlsx from "../../components/common/export/generateXlsx";
import Rejected from "../../assets/svg/deactiveate-user.svg";
import { findGraphemeClusters } from "../../components/common/ui/findGraphemeClusters.js";
import useManagementUserAccessPermission from "../../hooks/useManagementUserAccessPermission";


function PublicUserPhoto() {
  const location = useLocation();
  const { row } = location.state || {};
  const commonFacilityCode = useSelector(
    (state) => state.auth.commonFacilityCode
  );
  const rows = useSelector((x) => x?.publicUser?.PublicUserrow);
  const { PuIntitialphotosSearch: photoList } = useSelector((x) => x?.publicUser);
  const [showSearchFields, setShowSearchFields] = useState(false);
  const { accessPermission, InmateAccessPermission, PuAccessPermission } = useManagementUserAccessPermission();

  useEffect(() => {
    dispatch(publicUserActions?.setPublicUserListRow(row || rows));
  }, []);

  let initialPhoto = {
    ...photoList,
    facilityID: commonFacilityCode,
    userID: row?.PublicUserID || rows?.PublicUserID,
  };

  const dispatch = useDispatch();
  const { user } = useSelector((x) => x.auth);
  const {
    photogridList: loadPhotoList,
    loadPhotoExcelList,
    inmateLastName,
    inmateFirstName,
    PublicUserCurrentTab,
    infoInformationList,
    loading,
  } = useSelector((x) => x.publicUser);
  const [isloading, setIsLoading] = useState(false);
  const { ActiveStatus } = useSelector((x) => x.dropdownOptions);
  const [linkshow, setLinkshow] = useState(false);
  useEffect(() => {
    if (row?.PublicUserID || rows?.PublicUserID) {
      dispatch(publicUserActions?.setPuIntitialphotosSearch({
        ...photoList,
        facilityID: commonFacilityCode,
        userID: row?.PublicUserID || rows?.PublicUserID,
      }));
      if (photoList?.inmateFirstNameID === 0 || photoList?.inmateFirstNameID === undefined) {
        dispatch(
          publicUserActions.GetInmateFirstName({
            facilityID: commonFacilityCode,
            lastName: "",
            PublicUserID: row?.PublicUserID || rows?.PublicUserID,
          })
        );
      }
      dispatch(
        publicUserActions.GetInmateLastName({
          facilityID: commonFacilityCode,
          firstName: "",
          PublicUserID: row?.PublicUserID || rows?.PublicUserID,
        })
      );
    }
  }, [row?.PublicUserID || rows?.PublicUserID]);

  useEffect(() => {
    if (PublicUserCurrentTab === "publicuser-photos-tab") {
      dispatch(publicUserActions?.setPuIntitialphotosSearch(initialPhoto));
      setIsLoading(true);
      dispatch(publicUserActions.LoadPhotoSearchResult(initialPhoto)).then((x) => setIsLoading(false));
    }
  }, [PublicUserCurrentTab]);

  //Export
  useEffect(() => {
    if (loadPhotoExcelList && loadPhotoExcelList?.DataList?.length > 0) {
      let title = "Photo_List";
      let generateExcelColumns = [
        "Subject",
        "From",
        "To",
        "Inmate ID",
        "Photo Cost($)",
        "Sent On",
        "Status",
      ];

      // Map the account manager list to match the Excel format
      let PUPhoto_List =
        loadPhotoExcelList?.DataList?.map((obj) => ({
          Subject: obj.PhotoSubject,
          From: obj.PhotoFrom,
          To: obj.PhotoTo,
          Inmate_ID: obj?.InmateResidentId,
          PhotoCost: obj.PhotoCost.toFixed(2),
          Sent: obj.PhotoSentDate,
          Status: obj.PhotoActionStatus,
        })) || [];

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(PUPhoto_List, generateExcelColumns, title);

        // Clear excel data after the download
        dispatch(publicUserActions.clearPhotoExcelList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        console.error("Error generating Excel file:", error);
      }
    }
  }, [loadPhotoExcelList]);

  const handlePageChange = (pageNo) => {
    if (sorting) {
      sorting = false;
      return;
    }
    dispatch(publicUserActions?.setPuIntitialphotosSearch({
      ...photoList, facilityID: commonFacilityCode,
      userID: row?.PublicUserID || rows?.PublicUserID, pageNo: pageNo
    }));
    dispatch(publicUserActions.LoadPhotoSearchResult({
      ...photoList, facilityID: commonFacilityCode,
      userID: row?.PublicUserID || rows?.PublicUserID, pageNo: pageNo
    }));
  };

  const handleRowPerPage = (rowCount) => {
    dispatch(publicUserActions?.setPuIntitialphotosSearch({
      ...photoList, facilityID: commonFacilityCode,
      userID: row?.PublicUserID || rows?.PublicUserID, rowCountPerPage: rowCount, pageNo: 1
    }));
    dispatch(publicUserActions.LoadPhotoSearchResult({
      ...photoList, facilityID: commonFacilityCode,
      userID: row?.PublicUserID || rows?.PublicUserID, pageNo: 1, rowCountPerPage: rowCount
    }));
  };
  let sorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = {
      ...photoList, facilityID: commonFacilityCode,
      userID: row?.PublicUserID || rows?.PublicUserID
    };
    const newSortOrder = search.sortField?.includes(column.key)
      ? search.sortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortField = `${column.key} ${newSortOrder}`;
    dispatch(publicUserActions?.setPuIntitialphotosSearch(search));

    dispatch(
      publicUserActions.LoadPhotoSearchResult({
        ...photoList,
        facilityID: commonFacilityCode,
        userID: row?.PublicUserID || rows?.PublicUserID,
        sortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  let updatedSearch = { ...photoList, facilityID: commonFacilityCode, userID: row?.PublicUserID || rows?.PublicUserID };
  const handleSelectChange = (selectedOption, name) => {
    const LoadPhotoGridList = () => {
      updatedSearch.pageNo = 1;
      updatedSearch.rowCountPerPage = 10;
      updatedSearch.sortField = "PhotoCommID DESC";
      dispatch(publicUserActions.LoadPhotoSearchResult(updatedSearch));
    };

    const handleFirstName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.inmateFirstNameID = selectedOption?.value || 0;

      dispatch(
        publicUserActions.GetInmateLastName({
          facilityID: commonFacilityCode,
          firstName: "",
          PublicUserID: row?.PublicUserID || rows?.PublicUserID,
        })
      );

      LoadPhotoGridList();
    };

    const handleLastName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.inmateLastNameID = selectedOption?.value || 0;

      updatedSearch.inmateFirstName = "";
      updatedSearch.inmateFirstNameID = 0;
      if (row?.PublicUserID || rows?.PublicUserID) {
        dispatch(
          publicUserActions.GetInmateFirstName({
            facilityID: commonFacilityCode,
            lastName: updatedSearch?.inmateLastName,
            PublicUserID: row?.PublicUserID || rows?.PublicUserID,
          })
        );
      }

      LoadPhotoGridList();
    };

    switch (name) {
      case "inmateLastName":
        handleLastName();
        break;

      case "inmateFirstName":
        handleFirstName();
        break;

      default:
        updatedSearch[name] = selectedOption?.value || 4;
        LoadPhotoGridList();
        break;
    }
    dispatch(publicUserActions?.setPuIntitialphotosSearch(updatedSearch));
  };

  const handleDateChange = (value, name) => {
    const date = fDate(value);
    updatedSearch[name] = date || "";

    dispatch(publicUserActions?.setPuIntitialphotosSearch(updatedSearch));
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "noticesFromDate") {
      if (
        updatedSearch.noticesToDate &&
        new Date(value) > new Date(updatedSearch.noticesToDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "noticesToDate") {
      if (
        updatedSearch.noticesFromDate &&
        new Date(value) < new Date(updatedSearch.noticesFromDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...updatedSearch,
      noticesFromDate:
        fieldName === "noticesFromDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : updatedSearch.noticesFromDate, // preserve existing value
      noticesToDate:
        fieldName === "noticesToDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : updatedSearch.noticesToDate, // preserve existing value
    };
    dispatch(publicUserActions?.setPuIntitialphotosSearch(updatedParam));
  };

  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && updatedSearch[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleChange = (e) => {
    let { name, value } = e?.target;

    if (name === "inmateResidentID") {
      updatedSearch[name] = value.replace(/[^0-9]/g, "");
    } else {
      updatedSearch[name] = value;
    }
    dispatch(publicUserActions?.setPuIntitialphotosSearch(updatedSearch));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(publicUserActions?.setPuIntitialphotosSearch({
      ...photoList, facilityID: commonFacilityCode,
      userID: row?.PublicUserID || rows?.PublicUserID, pageNo: 1, rowCountPerPage: 10
    }));
    setIsLoading(true);
    dispatch(publicUserActions.LoadPhotoSearchResult({
      ...photoList, facilityID: commonFacilityCode,
      userID: row?.PublicUserID || rows?.PublicUserID, pageNo: 1, rowCountPerPage: 10
    })).then((x) => setIsLoading(false));
  };

  const handleReset = () => {
    dispatch(publicUserActions?.resetPuInitialPhotosSearch());
    const PublicUserInitialPhotosSearch = {
      facilityID: commonFacilityCode,
      inmateID: 0,
      inmateResidentID: "",
      managementUserID: 1,
      userID: row?.PublicUserID || rows?.PublicUserID,
      userFirstName: "",
      userLastName: "",
      photoAccess: 0,
      inmateFirstName: "",
      inmateFirstNameID: 0,
      inmateLastName: "",
      inmateLastNameID: 0,
      subject: "",
      noticesFromDate: getPastDate(6),
      noticesToDate: getCurrentDate(),
      activeStatus: 4,
      receiverRead: 4,
      pageNo: 1,
      rowCountPerPage: 10,
      sortField: "PhotoCommID DESC",
    }
    dispatch(publicUserActions.LoadPhotoSearchResult(PublicUserInitialPhotosSearch));
    if (row?.PublicUserID) {
      dispatch(
        publicUserActions.GetInmateFirstName({
          facilityID: commonFacilityCode,
          lastName: "",
          PublicUserID: row?.PublicUserID,
        })
      );
    }
    dispatch(
      publicUserActions.GetInmateLastName({
        facilityID: commonFacilityCode,
        firstName: "",
        PublicUserID: row?.PublicUserID,
      })
    );
  };

  const columns = [
    {
      name: "Subject",
      selector: (row) => row.PhotoSubject,
      key: "PhotoSubject",
      cell: (row) => (
        <div className="d-flex flex-wrap gap-2 align-items-start">
          <div
            className={` ${accessPermission[0]?.SubMenuActiveStatus !== 0
              ? "Common_Link_Style"
              : ""
              }`}
            onClick={() => handleNavigatePhotos(row?.PhotoCommID)}
          >
            {/* {row.PhotoSubject} */}
            {findGraphemeClusters(row.PhotoSubject, false)?.length > 15
              ? findGraphemeClusters(row.PhotoSubject, true)
              : row.PhotoSubject}
          </div>
          {row?.UserPhotoReadStatus == false && (
            // <span className="animate-beat fs-6 text-nowrap text-red fw-bold">
            //   New
            // </span>
            <div class="newbutton-container">
              New
              <div class="border-animation"></div>
            </div>
          )}
        </div>
      ),
      sortable: true,
    },
    {
      width: "120px",
      name: "From",
      selector: (row) => row?.PhotoFrom,
      key: "PhotoFrom",
      cell: (row) => (
        <div className="d-flex  gap-2 align-items-center">
          <div className="user-batch button-success "></div>
          <div
            className={` ${PuAccessPermission[0]?.SubMenuActiveStatus !== 0 ? "Common_Link_Style" : ""}`}
            onClick={() => handleNavigatePublicInfo(row)}
          >
            {row?.PhotoFrom}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      width: "120px",
      name: "To",
      selector: (row) => row.PhotoTo,
      key: "PhotoTo",
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center">
          <div className="user-batch button-primary "></div>
          <div
            className={` ${InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 ? "Common_Link_Style" : ""}`}
            onClick={() => handleNavigateInmateInfo(row)}
          >
            {row.PhotoTo}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Inmate ID",
      selector: (row) => row?.InmateResidentId,
      key: "InmateResidentId",
      cell: (row) => (
        <div className="d-flex flex-wrap gap-2 align-items-center">
          <div
            className={` ${InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 ? "Common_Link_Style" : ""}`}
            onClick={() => handleNavigateInmateInfoInmateId(row)}
          >
            {row.InmateResidentId}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Photo Cost ($)",
      key: "PhotoCost",
      selector: (row) => row.PhotoCost.toFixed(2), // Format as currency
      sortable: true,
    },
    {
      name: "Sent On",
      selector: (row) => row.PhotoSentDate,
      key: "PhotoSentDate",
      cell: (row) => <div title={row?.PhotoSentDate}>{row?.PhotoSentDate}</div>,
      sortable: true,
    },
    {
      name: "Status",
      key: "PhotoActionStatus",
      sortable: true,
      selector: (row) => row.PhotoActionStatus,

      cell: (row) => {
        return (
          <div>
            <img
              title={
                row.PhotoActionStatus === "Pending"
                  ? "Pending"
                  : row.PhotoActionStatus === "Approved"
                    ? "Approved"
                    : row.PhotoActionStatus === "Rejected"
                      ? "Rejected"
                      : ""
              }
              src={
                row.PhotoActionStatus === "Pending"
                  ? Pending
                  : row.PhotoActionStatus === "Approved"
                    ? Approved
                    : row.PhotoActionStatus === "Rejected"
                      ? Rejected
                      : ""
              }
              style={{ width: "20px", height: "20px" }} // Adjust icon size as needed
            />
          </div>
        );
      },
      center: true,
    },
  ];

  const handleNavigatePublicInfo = () => {
    if (PuAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    history.navigate("PublicUserList/Details", {
      state: { row: row, source: "publicUserPhoto" },
    });
    dispatch(publicUserActions?.setPublicUserTab("publicuser-info-tab"));
  };
  const handleNavigateInmateInfo = (row) => {
    if (InmateAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    dispatch(publicUserActions?.setPublicMessageValue(row));
    dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
    history.navigate("InmateList/Details", {
      state: { inmate: row, source: "publicUserPhoto", row: row },
    });
    //dispatch(publicUserActions?.setPublicUserTab("publicuser-info-tab"));
  };
  const handleNavigateInmateInfoInmateId = (row) => {
    if (InmateAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    dispatch(publicUserActions?.setPublicMessageValue(row));
    dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
    history.navigate("InmateList/Details", {
      state: {
        inmate: row,
        source: "publicUserPhoto",
        row: row,
        showTransactionTab: false,
      },
    });
  };

  const handleNavigatePhotos = (id) => {
    if (linkshow === true) return;
    if (accessPermission[0]?.SubMenuActiveStatus === 0) {
      // showToastNotification(
      //   "View option has been disabled by the admin.",
      //   "error"
      // );
      setLinkshow(true);
      return;
    }
    //if (accessPermission[0]?.SubMenuActiveStatus === 0) return;
    history.navigate("/Admin/PhotoList/info", {
      state: { photoCommID: id, source: "publicUserPhoto", row: row },
    });


  };

  const handleClickExcel = () => {
    const updateTotalRows = {
      ...photoList,
      facilityID: commonFacilityCode,
      userID: row?.PublicUserID || rows?.PublicUserID,
      RowCountPerPage: loadPhotoList?.TotalRecordCount,
      exportExcel: true,
      pageNo: 1,
    };

    dispatch(publicUserActions.LoadPhotoSearchResult(updateTotalRows));
  };

  const handleBack = () => {
    history.navigate("PublicUserList");
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form>
        <div className="row">
          <div className="p-2 m-1 d-flex flex-wrap align-items-center">
            <div className="col-md-4 col-sm-12 d-flex flex-wrap align-items-center me-1">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Public User Last Name :
              </label>

              <strong className="fs-5 text-end mx-2">
                {row?.LastName ||
                  rows?.LastName ||
                  infoInformationList?.LastName}
              </strong>
            </div>

            <div className="col-md-4 col-sm-12 d-flex flex-wrap align-items-center">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Public User First Name :
              </label>
              <strong className="fs-5 text-end mx-2">
                {row?.FirstName ||
                  rows?.FirstName ||
                  infoInformationList?.FirstName}
              </strong>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <NumberInput
                name="inmateResidentID"
                label="Inmate ID"
                value={photoList?.inmateResidentID}
                handleChange={handleChange}
                maxLength={18}
                placeholder="Enter Inmate ID"
                type="text"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={inmateLastName}
                value={photoList?.inmateLastNameID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "inmateLastName")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={photoList?.inmateLastNameID !== 0}
                placeholder="Select State"
                label="Inmate Last Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={inmateFirstName}
                value={photoList?.inmateFirstNameID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "inmateFirstName")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={photoList?.inmateFirstNameID !== 0}
                placeholder="Select State"
                label="Inmate First Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <TextInput
                name="subject"
                id="subject"
                label="Subject"
                value={photoList?.subject}
                handleChange={handleChange}
                placeholder="Enter Subject"
                maxLength={50}
                required={false}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <DateInput
                value={photoList.noticesFromDate}
                handleChange={(e) => handleDateChange(e, "noticesFromDate")}
                name="noticesFromDate"
                label={"From Date"}
                maxDate={
                  photoList?.noticesToDate
                    ? photoList?.noticesToDate
                    : new Date()
                }
                minDate={new Date(2017, 0, 1)}
                required={false}
                disabled={false}
                yearDropDown={false}
                monthDropDown={false}
                isClearable={
                  photoList.noticesFromDate !== null &&
                  photoList.noticesFromDate !== ""
                }
                className={false ? "disabled-date-input" : ""}
                handleBlur={(e) => handleDateBlur(e, "noticesFromDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "noticesFromDate")}
              ></DateInput>
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <DateInput
                value={photoList?.noticesToDate}
                handleChange={(e) => handleDateChange(e, "noticesToDate")}
                name="noticesToDate"
                minDate={
                  photoList?.noticesFromDate
                    ? photoList?.noticesFromDate
                    : new Date(2017, 0, 1)
                }
                label={"To Date"}
                maxDate={new Date()}
                required={false}
                disabled={false}
                isClearable={
                  photoList.noticesToDate !== null &&
                  photoList.noticesToDate !== ""
                }
                yearDropDown={false}
                monthDropDown={false}
                handleBlur={(e) => handleDateBlur(e, "noticesToDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "noticesToDate")}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={ActiveStatus}
                value={photoList?.activeStatus}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "activeStatus")
                }
                isClearable={photoList?.activeStatus !== 4}
                isMulti={false}
                defaultValue={ActiveStatus[4]}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                placeholder="Select Status"
                label={"Status"}
              />
            </div>
          </div>
        </div>

        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            onClick={handleSubmit}
            icon={"search"}
          ></Button>
          <Button
            variant="danger"
            className="me-2"
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            onClick={handleReset}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  if (loading || isloading) return <CustomLoader />;

  return (
    <div>
      <div className=" p-2 ">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap">
          <h4 className="inner-subheader-bg text-color">
            <i class="fa fa-camera me-2"></i>Photos
          </h4>
          <Button
            label="Back"
            type="button"
            //className="btn btn-danger"
            onClick={handleBack}
            variant="danger"
            icon={"fa-solid fa-angle-left"}
            status={"primary"}
            disabled={false}
          />
        </div>
      </div>
      <div className="card shadow-sm b-r-all p-4 border border-dark-grey  w-100">
        {/* Mobile only (Below md breakpoint) */}
        <div className=" d-block d-md-none">
          <div
            className=" d-flex align-items-center justify-content-between"
            style={{ background: "transparent", cursor: "pointer" }}
            onClick={toggleInformation}
          >
            <h2 className="form_title_uppercase text-color"> SEARCH</h2>
            <i
              id="itagInformation"
              className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
        </div>
        {/* Mobile only (Below md breakpoint) */}
        <div className="d-block d-md-none mt-2">
          {showSearchFields && renderSearch()}
        </div>

        {/* Web only (Desktop and above) */}
        <div className="mb-3 d-none d-md-block">
          <h2 className="form_title_uppercase text-color"> SEARCH</h2>
        </div>

        {/* Web only (Desktop and above) */}
        <div className="d-none d-md-block">{renderSearch()}</div>
        {/* <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap">
          <h2 className="form_title_uppercase text-color">search</h2>
        </div> */}
        {/* <form>
          <div className="row">
            <div className="p-3 m-0 d-flex flex-wrap align-items-center">
              <div className="col-md-4 d-flex flex-wrap align-items-center me-4">
                <label className="fs-5" style={{ minWidth: "150px" }}>
                  Public User Last Name :
                </label>

                <strong className="fs-5 text-end mx-2">
                  {row?.LastName ||
                    rows?.LastName ||
                    infoInformationList?.LastName}
                </strong>
              </div>

              <div className="col-md-4 d-flex flex-wrap align-items-center">
                <label className="fs-5" style={{ minWidth: "150px" }}>
                  Public User First Name :
                </label>
                <strong className="fs-5 text-end mx-2">
                  {row?.FirstName ||
                    rows?.FirstName ||
                    infoInformationList?.FirstName}
                </strong>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <div className="form-floating mb-3">
                <NumberInput
                  name="inmateResidentID"
                  label="Inmate ID"
                  value={photoList?.inmateResidentID}
                  handleChange={handleChange}
                  maxLength={18}
                  placeholder="Enter Inmate ID"
                  type="text"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <div className="form-floating mb-3">
                <SelectInput
                  options={inmateLastName}
                  value={photoList?.inmateLastNameID}
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "inmateLastName")
                  }
                  isMulti={false}
                  closeMenuOnSelect={true}
                  isDisabled={false}
                  isLoading={false}
                  isClearable={photoList?.inmateLastNameID !== 0}
                  placeholder="Select State"
                  label="Inmate Last Name"
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-floating mb-3">
                <SelectInput
                  options={inmateFirstName}
                  value={photoList?.inmateFirstNameID}
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "inmateFirstName")
                  }
                  isMulti={false}
                  closeMenuOnSelect={true}
                  isDisabled={false}
                  isLoading={false}
                  isClearable={photoList?.inmateFirstNameID !== 0}
                  placeholder="Select State"
                  label="Inmate First Name"
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-floating mb-3">
                <TextInput
                  name="subject"
                  id="subject"
                  label="Subject"
                  value={photoList?.subject}
                  handleChange={handleChange}
                  placeholder="Enter Subject"
                  maxLength={50}
                  required={false}
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-floating mb-3">
                <DateInput
                  value={photoList.noticesFromDate}
                  handleChange={(e) => handleDateChange(e, "noticesFromDate")}
                  name="noticesFromDate"
                  label={"From Date"}
                  maxDate={
                    photoList?.noticesToDate
                      ? photoList?.noticesToDate
                      : new Date()
                  }
                  minDate={new Date(2017, 0, 1)}
                  required={false}
                  disabled={false}
                  yearDropDown={false}
                  monthDropDown={false}
                  isClearable={
                    photoList.noticesFromDate !== null &&
                    photoList.noticesFromDate !== ""
                  }
                  className={false ? "disabled-date-input" : ""}
                  handleBlur={(e) => handleDateBlur(e, "noticesFromDate")}
                  handleKeyDown={(e) =>
                    handleDateEnterKey(e, "noticesFromDate")
                  }
                ></DateInput>
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-floating mb-3">
                <DateInput
                  value={photoList?.noticesToDate}
                  handleChange={(e) => handleDateChange(e, "noticesToDate")}
                  name="noticesToDate"
                  minDate={
                    photoList?.noticesFromDate
                      ? photoList?.noticesFromDate
                      : new Date(2017, 0, 1)
                  }
                  label={"To Date"}
                  maxDate={new Date()}
                  required={false}
                  disabled={false}
                  isClearable={
                    photoList.noticesToDate !== null &&
                    photoList.noticesToDate !== ""
                  }
                  yearDropDown={false}
                  monthDropDown={false}
                  handleBlur={(e) => handleDateBlur(e, "noticesToDate")}
                  handleKeyDown={(e) => handleDateEnterKey(e, "noticesToDate")}
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-floating mb-3">
                <SelectInput
                  options={ActiveStatus}
                  value={photoList?.activeStatus}
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "activeStatus")
                  }
                  isClearable={photoList?.activeStatus !== 4}
                  isMulti={false}
                  defaultValue={ActiveStatus[4]}
                  closeMenuOnSelect={true}
                  isDisabled={false}
                  isLoading={false}
                  placeholder="Select Status"
                  label={"Status"}
                />
              </div>
            </div>
          </div>

          <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
            <Button
              className="me-2"
              label={"SEARCH"}
              type={"submit"}
              status={"primary"}
              disabled={false}
              onClick={handleSubmit}
              icon={"search"}
            ></Button>
            <Button
              variant="danger"
              className="me-2"
              label={"RESET"}
              type={"button"}
              status={"secondary"}
              onClick={handleReset}
              disabled={false}
              icon={"fa-solid fa-rotate-right"}
            />
          </div>
        </form> */}
      </div>
      <div className="mt-3">
        <div className="d-flex flex-wrap  justify-content-end mb-3">
          {loadPhotoList?.DataList?.length > 0 && (
            <ExcelExport
              variant="soft-gray"
              handleExcelExport={handleClickExcel}
            />
          )}
        </div>

        <Table
          columns={columns}
          data={loadPhotoList?.DataList}
          pagination={true}
          onChangeRowsPerPage={handleRowPerPage}
          onChangePage={handlePageChange}
          totalRowCount={loadPhotoList?.TotalRecordCount}
          currentPage={photoList?.pageNo}
          paginationPerPage={photoList.rowCountPerPage}
          onSort={handleSort}
          serverSideSort
          sortColumn={photoList?.sortField?.split(" ")[0]}
          sortDirection={photoList?.sortField?.split(" ")[1]}
        />
      </div>
    </div>
  );
}

export default React.memo(PublicUserPhoto);
